import React from "react";
import { Link } from "react-router-dom";
import SectionTitle from "../SectionTitle/SectionTitle";
import Products from "../../data/Products";

const ServiceSection = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  const {
    hclass,
    sliceStart = 0,
    sliceEnd = 3,
    showSectionTitle = true,
    AllServices = true,
  } = props;
  return (
    <section className={hclass}>
      <div className="container">
        {showSectionTitle && (
          <div className="row justify-content-center">
            <div className="col-lg-9 col-12">
              <SectionTitle
                title={"Our Products"}
                subtitle={"Reliable Equipment for Professionals"}
              />
            </div>
          </div>
        )}
        <div className="row">
          {Products.slice(sliceStart, sliceEnd).map((servic, sky) => (
            <div className="col-lg-4 col-md-6 col-12" key={sky}>
              <div className="service_card">
                <div className="icon">
                  <img src={servic.icon} alt={servic.title}></img>
                </div>
                <div className="content">
                  <h2>{servic.title}</h2>
                  <p>{servic.shortDesc}</p>
                  <Link
                    onClick={ClickHandler}
                    to={`/product/${servic.subcategories[0].slug}`}
                    aria-label={`View more about ${servic.title}`}
                  >
                    <i className="flaticon-right-arrow"></i>
                  </Link>
                </div>
              </div>
            </div>
          ))}
          {AllServices && (
            <div className="col-12">
              <div className="btn">
                <Link
                  onClick={ClickHandler}
                  to={"/products"}
                  className="theme-btn"
                >
                  View All Products
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ServiceSection;
